import { TypedAction } from '@ngrx/store/src/models';
import { AppStateFailureBuilder, AppStateFailureItemWithErrorCode, FailureType } from '@symphony-solo/shared/common-state/src';
import { ApiResponseCode, LoyaltyResponse } from '@symphony-solo/shared/http/src';
import { authenticateErrorAction, AuthenticationActionTypes } from '../+state';
import { TokenResult } from '../models';
import { BaseHandler } from './base.handler';

export class ValidationFailedHandler extends BaseHandler {
  public handle(response: LoyaltyResponse<TokenResult>): TypedAction<AuthenticationActionTypes> {
    if (response.soloResponseCode === ApiResponseCode.Account_Not_Validated) {
      const failure = new AppStateFailureBuilder()
        .setFailureType(FailureType.Validation)
        .addFailure(new AppStateFailureItemWithErrorCode('Invalid Credentials', ApiResponseCode.Account_Not_Validated))
        .build();
      return authenticateErrorAction({ failure });
    }
    return this.nextHandler.handle(response);
  }
}
